import { createContext } from 'react';

const TutorialContext = createContext(null);

export default TutorialContext;
